import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function NYCAccountingCta() {
  return <section className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-53">
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-54"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-55">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-56">
          Ready to reach local accounting business owners in NYC?
        </h2>
        <p className="text-lg text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-57">
          Stop wasting time with outdated lists. Get instant access to 3,450+
          verified local accounting businesses in New York City with verified
          emails and phones.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-58">
          <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-50 transition-colors text-base w-full sm:w-auto" data-id="element-59">
            Try verified contacts for free
            <ArrowRightIcon className="w-5 h-5" data-id="element-60" />
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-white/90" data-id="element-61">
          <div className="flex items-center gap-2" data-id="element-62">
            <CheckIcon className="w-4 h-4 text-white" data-id="element-63" />
            <span data-id="element-64">No credit card required</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-65">
            <CheckIcon className="w-4 h-4 text-white" data-id="element-66" />
            <span data-id="element-67">100 free verified contacts</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-68">
            <CheckIcon className="w-4 h-4 text-white" data-id="element-69" />
            <span data-id="element-70">Export to CSV/CRM</span>
          </div>
        </div>
      </div>
    </section>;
}